/* eslint-disable-next-line no-restricted-imports */
import type { WeightValueCondition } from '@jane/shared/models';

export const COMMON_WEIGHTS: { [key: string]: WeightValueCondition } = {
  '0.5g': { units: 'g', value: 0.5 },
  '1g': { units: 'g', value: 1 },
  '2g': { units: 'g', value: 2 },
  '3.5g': { units: 'g', value: 3.5 },
  '7g': { units: 'g', value: 7 },
  '14g': { units: 'g', value: 14 },
  '28g': { units: 'g', value: 28 },
};

export const UNCOMMON_WEIGHTS: { [key: string]: WeightValueCondition } = {
  '0.01g': { units: 'g', value: 0.01 },
  '0.02g': { units: 'g', value: 0.02 },
  '0.025g': { units: 'g', value: 0.025 },
  '0.03g': { units: 'g', value: 0.03 },
  '0.04g': { units: 'g', value: 0.04 },
  '0.05g': { units: 'g', value: 0.05 },
  '0.06g': { units: 'g', value: 0.06 },
  '0.07g': { units: 'g', value: 0.07 },
  '0.08g': { units: 'g', value: 0.08 },
  '0.09g': { units: 'g', value: 0.09 },
  '0.1g': { units: 'g', value: 0.1 },
  '0.11g': { units: 'g', value: 0.11 },
  '0.12g': { units: 'g', value: 0.12 },
  '0.13g': { units: 'g', value: 0.13 },
  '0.15g': { units: 'g', value: 0.15 },
  '0.18g': { units: 'g', value: 0.18 },
  '0.2g': { units: 'g', value: 0.2 },
  '0.22g': { units: 'g', value: 0.22 },
  '0.24g': { units: 'g', value: 0.24 },
  '0.25g': { units: 'g', value: 0.25 },
  '0.3g': { units: 'g', value: 0.3 },
  '0.33g': { units: 'g', value: 0.33 },
  '0.35g': { units: 'g', value: 0.35 },
  '0.4g': { units: 'g', value: 0.4 },
  '0.42g': { units: 'g', value: 0.42 },
  '0.44g': { units: 'g', value: 0.44 },
  '0.45g': { units: 'g', value: 0.45 },
  '0.55g': { units: 'g', value: 0.55 },
  '0.6g': { units: 'g', value: 0.6 },
  '0.65g': { units: 'g', value: 0.65 },
  '0.7g': { units: 'g', value: 0.7 },
  '0.75g': { units: 'g', value: 0.75 },
  '0.8g': { units: 'g', value: 0.8 },
  '0.84g': { units: 'g', value: 0.84 },
  '0.85g': { units: 'g', value: 0.85 },
  '0.9g': { units: 'g', value: 0.9 },
  '0.95g': { units: 'g', value: 0.95 },
  '1.1g': { units: 'g', value: 1.1 },
  '1.2g': { units: 'g', value: 1.2 },
  '1.25g': { units: 'g', value: 1.25 },
  '1.3g': { units: 'g', value: 1.3 },
  '1.35g': { units: 'g', value: 1.35 },
  '1.4g': { units: 'g', value: 1.4 },
  '1.5g': { units: 'g', value: 1.5 },
  '1.6g': { units: 'g', value: 1.6 },
  '1.68g': { units: 'g', value: 1.68 },
  '1.7g': { units: 'g', value: 1.7 },
  '1.75g': { units: 'g', value: 1.75 },
  '1.8g': { units: 'g', value: 1.8 },
  '2.1g': { units: 'g', value: 2.1 },
  '2.2g': { units: 'g', value: 2.2 },
  '2.25g': { units: 'g', value: 2.25 },
  '2.4g': { units: 'g', value: 2.4 },
  '2.45g': { units: 'g', value: 2.45 },
  '2.5g': { units: 'g', value: 2.5 },
  '2.6g': { units: 'g', value: 2.6 },
  '2.8g': { units: 'g', value: 2.8 },
  '2.83g': { units: 'g', value: 2.83 },
  '3g': { units: 'g', value: 3 },
  '3.4g': { units: 'g', value: 3.4 },
  '3.6g': { units: 'g', value: 3.6 },
  '3.7g': { units: 'g', value: 3.7 },
  '3.75g': { units: 'g', value: 3.75 },
  '4g': { units: 'g', value: 4 },
  '4.2g': { units: 'g', value: 4.2 },
  '4.5g': { units: 'g', value: 4.5 },
  '4.8g': { units: 'g', value: 4.8 },
  '5g': { units: 'g', value: 5 },
  '5.25g': { units: 'g', value: 5.25 },
  '5.4g': { units: 'g', value: 5.4 },
  '5.5g': { units: 'g', value: 5.5 },
  '5.6g': { units: 'g', value: 5.6 },
  '5.66g': { units: 'g', value: 5.66 },
  '6g': { units: 'g', value: 6 },
  '6.5g': { units: 'g', value: 6.5 },
  '7.2g': { units: 'g', value: 7.2 },
  '7.5g': { units: 'g', value: 7.5 },
  '7.8g': { units: 'g', value: 7.8 },
  '8g': { units: 'g', value: 8 },
  '8.49g': { units: 'g', value: 8.49 },
  '9g': { units: 'g', value: 9 },
  '10g': { units: 'g', value: 10 },
  '10.5g': { units: 'g', value: 10.5 },
  '11g': { units: 'g', value: 11 },
  '11.32g': { units: 'g', value: 11.32 },
  '12g': { units: 'g', value: 12 },
  '12.5g': { units: 'g', value: 12.5 },
  '14.1g': { units: 'g', value: 14.1 },
  '14.15g': { units: 'g', value: 14.15 },
  '14.17g': { units: 'g', value: 14.17 },
  '15g': { units: 'g', value: 15 },
  '20g': { units: 'g', value: 20 },
  '21g': { units: 'g', value: 21 },
  '28.3g': { units: 'g', value: 28.3 },
  '300mg': { units: 'mg', value: 300 },
  '500mg': { units: 'mg', value: 500 },
  '800mg': { units: 'mg', value: 800 },
  '1000mg': { units: 'mg', value: 1000 },
  '5ml': { units: 'ml', value: 5 },
  '10ml': { units: 'ml', value: 10 },
  '15ml': { units: 'ml', value: 15 },
  '30ml': { units: 'ml', value: 30 },
  '50ml': { units: 'ml', value: 50 },
  '355ml': { units: 'ml', value: 355 },
  '1fl oz': { units: 'fl_oz', value: 1 },
  '2fl oz': { units: 'fl_oz', value: 2 },
  '4fl oz': { units: 'fl_oz', value: 4 },
  '12fl oz': { units: 'fl_oz', value: 12 },
  '1oz': { units: 'oz', value: 1 },
  '2oz': { units: 'oz', value: 2 },
  '4oz': { units: 'oz', value: 4 },
  '12oz': { units: 'oz', value: 12 },
};

export const ALL_WEIGHTS = { ...COMMON_WEIGHTS, ...UNCOMMON_WEIGHTS };

/**
 * Converts an array of WeightValueCondition objects to an array of objects with label and value fields.
 * The label corresponds to the matching key in ALL_WEIGHTS and the value contains the original WeightValueCondition.
 * @param weightConditions - Array of WeightValueCondition objects to transform
 * @returns Array of objects with label and value fields
 */
export const transformWeightConditions = (
  weightConditions: WeightValueCondition[]
): Array<{ label: string; value: WeightValueCondition }> => {
  return weightConditions.reduce<
    { label: string; value: WeightValueCondition }[]
  >((prev, condition) => {
    // Find the matching key in ALL_WEIGHTS
    const label =
      Object.entries(ALL_WEIGHTS).find(
        ([_, weightValue]) =>
          weightValue.units === condition.units &&
          weightValue.value === condition.value
      )?.[0] || `${condition.value}${condition.units}`; // Fallback if no match found

    if (label) {
      prev.push({
        label,
        value: condition,
      });
    }
    return prev;
  }, []);
};
